class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.footerVisible = false
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.footerObserver = new IntersectionObserver(
      this.onFooterIntersect.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    )

    if (this.externalEls.footer.element) {
      this.footerObserver.observe(this.externalEls.footer.element)
    }
  }

  onFooterIntersect (entries) {
    entries.forEach((entry) => {
      this.footerVisible = entry.isIntersecting
      if (this.footerVisible) {
        this.classList.remove(this.dataset.visibleClass)
        document.body.classList.remove(this.dataset.bodyClass)
      } else {
        this.classList.add(this.dataset.visibleClass)
        document.body.classList.add(this.dataset.bodyClass)
      }
    })
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
